const BookingCTA = () => {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24 sm:px-8 lg:px-12">
      <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-r from-[#02212d] via-[#0f172a] to-[#11345d] p-8 sm:p-12">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(34,197,94,0.16),_transparent_40%)]" />
        <div className="absolute -right-36 top-14 h-44 w-44 rounded-full bg-emerald-500/10 blur-3xl" />
        <div className="relative grid gap-8 lg:grid-cols-2 lg:items-center">
          <div className="space-y-6">
            <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Ready to Play?</p>
            <h2 className="text-4xl font-semibold tracking-tight text-white sm:text-5xl">Secure your court time for regular play or coaching.</h2>
            <p className="max-w-xl text-slate-300">
              Regular play is open daily from 5:00 AM to 11:00 PM, and coaching runs Monday to Saturday from 5:00 PM to 7:00 PM.
            </p>
          </div>
          <div className="flex items-center justify-start">
            <a
              href="tel:+919840777003"
              className="btn-primary inline-flex items-center justify-center px-8 py-4 text-base"
            >
              Call to Book Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCTA;
